import { create } from "../../../common/utils/zustand_state_manager";
import { useCommonServices } from "./use_services";
import { CommonsRepository } from "../../../common/data/repositories/commons_repository";
import { ICommonsRepository } from "../../../common/domain/repositories/commons_repository";


type State = {
  commonsRepository: ICommonsRepository,
};

export const useCommonsRepositories = create<State>(() => {
  const {
    commonsService,
  } = useCommonServices.getState();

  return ({
    commonsRepository: new CommonsRepository(commonsService),
  });
});